import { EyeFilled } from "@ant-design/icons";
import { Button, Form, Input, Table } from "antd";
import Dragger from "antd/es/upload/Dragger";
import { useEffect, useMemo, useState } from "react";
import * as XLSX from "xlsx";
import { useAppSelector } from "../../../../app/store";
import DownloadIcon from "../../../../assets/icons/DownloadIcon";
import CustomModal from "../../../../components/ui/CustomModal";
import { useCreateBatchVendorMutation } from "../../../../features/portal/batch/batchApi";
import useError from "../../../../hooks/useError";
import useModal from "../../../../hooks/useModal";
import { toast } from "../../../../lib/toast";
import { stringToArray } from "../../../../utils/array";
import { sliceString } from "../../../../utils/string";

type Props = {
  open: boolean;
  handleClose: (val?: any) => void;
  batchCode?: string;
  batchName?: string;
  id?: string | number;

  // data?: any;
  // reRender: (val: boolean) => void;
  // uploadedCount: (val: number, total: number) => void;
};

export default function PaymentSalaryVendorModal({
  open,
  handleClose,
  batchCode,
  batchName,
  id,
}: // data: tableLength,
// reRender,
// uploadedCount,
Props) {
  const [form] = Form.useForm();
  const [fileName, setFileName] = useState("No file chosen");
  const [loading, setLoading] = useState(false);
  const [uploadedData, setUploadedData] = useState<any[]>([]);
  const projectId = localStorage.getItem("product_id");
  const { user } = useAppSelector((state) => state.auth);

  const {
    open: openPreview,
    handleOpen: handlePreviewOpen,
    handleClose: handleClosePreview,
  } = useModal();

  // const [createDisbursements, { isLoading, isError, error, isSuccess }] =
  //   useCreateDisbursementsMutation();
  const [
    createBatchVendor,
    {
      isError: isCreateVendorBatchError,
      error: createBatchVendorError,
      isLoading: isCreateVendorBatchLoading,
      isSuccess: isCreateVendorBatchSuccess,
    },
  ] = useCreateBatchVendorMutation();
  // useError(isError, error, "Salary disbursement data upload fail");
  useError(
    isCreateVendorBatchError,
    createBatchVendorError,
    "Vendor payment data uploaded fail"
  );

  const onFinish = async (values: any) => {
    if (!uploadedData?.length) {
      toast(
        "error",
        "Data is empty! please uploaded vendor payment excel again"
      );
      return;
    }

    const newData = uploadedData.map(({ name, ...rest }: any) => rest);
    // const nameData = uploadedData?.[0]?.name;
    const nameData = values?.batchName;

    // const updatedData = uploadedData?.map((item: any) => ({
    //   ...item,
    // }));

    const apiUploadData = {
      batch: {
        name: nameData,
        company_id: Number(user?.data?.company_id),
        project_id: Number(projectId),
        created_by: Number(user?.data?.id),
      },
      vendorPayment: newData,
    };

    // console.log("Excel vendor upload data", apiUploadData);

    createBatchVendor(apiUploadData);
  };

  const handleUploadFile = (file: any) => {
    if (
      file?.name?.endsWith(".xls") ||
      file?.name?.endsWith(".xlsx") ||
      file?.type === "application/vnd.ms-excel" ||
      file?.type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    ) {
      setLoading(true);
      const reader = new FileReader();
      reader.readAsBinaryString(file);

      const fileNameArr = stringToArray(file?.name, ".");
      setFileName(
        `${sliceString(file?.name, 30, "...")}.${
          fileNameArr?.[fileNameArr?.length - 1]
        }`
      );

      reader.onload = (e) => {
        const data = e?.target?.result;
        const workBook = XLSX.read(data, {
          type: "binary",
          cellDates: true,
          dateNF: "mm/dd/yyyy",
        });
        const sheetName = workBook.SheetNames[0];
        const sheet = workBook.Sheets[sheetName];
        let parsedData = XLSX.utils.sheet_to_json(sheet, {
          raw: false,
          defval: "",
        });

        const firstRow = parsedData[0] || {};
        const departmentKey = Object.keys(firstRow).find(
          (key) => key.trim().toLowerCase() === "department"
        );

        // Mapping and structuring data with required fields
        const transformedData = parsedData.map((el: any) => {
          // const rawDate =
          //   el?.["transaction_date"]?.trim() || el?.["Txn. Date"]?.trim() || "";

          // // Convert "20.03.2025" -> "2025-03-25"
          // const formattedDate = rawDate
          //   ? dayjs(rawDate, "DD.MM.YYYY").format("YYYY-MM-DD")
          //   : "";

          const normalized: Record<string, any> = {};
          Object.keys(el).forEach((key) => {
            normalized[key.replace(/[\s_]/g, "").toLowerCase()] =
              el[key]?.trim?.() ?? el[key];
          });

          const wallet_name =
            el?.["wallet_number"]?.trim() ||
            el?.["Wallet Number"]?.trim() ||
            "";

          const bank_name =
            el?.["bank_name"]?.trim() || el?.["Bank Name"]?.trim() || "";
          const account_title =
            el?.["account_title"]?.trim() ||
            el?.["Account Title"]?.trim() ||
            "";
          const account_number =
            el?.["account_number"]?.trim() ||
            el?.["Account Number"]?.trim() ||
            "";
          const branch_name =
            el?.["branch_name"]?.trim() || el?.["Branch Name"]?.trim() || "";
          const routing_number =
            el?.["routing_number"]?.trim() ||
            el?.["Routing Number"]?.trim() ||
            "";

          let disbursement_type = "";
          if (wallet_name) {
            disbursement_type = "wallet";
          } else if (
            bank_name ||
            account_title ||
            account_number ||
            branch_name ||
            routing_number
          ) {
            disbursement_type = "bank";
          }

          // --- Validation logic for amount ---
          const amount = Number(el?.["amount"] || el?.["Amount"] || 0);

          return {
            name: fileNameArr?.[0] || "",
            company_id: Number(user?.data?.company_id),
            vendor_id: normalized["vendorid"] || "",
            vendor_name:
              el?.["vendor_name"]?.trim() || el?.["Vendor Name"]?.trim() || "",
            invoiceNo:
              el?.["invoiceNo"]?.trim() || el?.["Invoice No"]?.trim() || "",
            amount,
            // department: departmentKey ? el[departmentKey]?.trim() || "" : "",
            // designation:
            //   el?.["designation"]?.trim() || el?.["Designation"]?.trim() || "",
            wallet_name,
            bankData: {
              bank_name,
              account_title,
              account_number,
              branch_name,
              routing_number,
            },
            narration:
              el?.["narration"]?.trim() || el?.["Narration"]?.trim() || "",
            status: "pending",
            remarks: el?.["remarks"]?.trim() || el?.["Remarks"]?.trim() || "",
            disbursement_type,
          };
        });

        // --- Validation: Check if any amount is less than 100 ---
        const invalidRow = transformedData.find((row: any) => row.amount < 10);
        if (invalidRow) {
          toast("error", "Amount cannot be less than 10 in any row.");
          setLoading(false);
          return;
        }

        // --- Validation: Check if any account_number contains letters ---
        const invalidAccount = transformedData.find(
          (row: any) =>
            row.bankData.account_number &&
            /[a-zA-Z]/.test(row.bankData.account_number)
        );
        if (invalidAccount) {
          toast("error", "Account number must not contain letters in any row.");
          setLoading(false);
          return;
        }

        setUploadedData(transformedData);
        setLoading(false);
      };
    } else {
      setLoading(false);
      toast("error", "Please uploadedd only excel file");
    }
  };

  useEffect(() => {
    if (isCreateVendorBatchSuccess) {
      toast("success", "Vendor payment data uploaded successfully");
      handleClose(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isCreateVendorBatchSuccess]);

  const previewColumns = useMemo(() => {
    if (!uploadedData.length) return [];
    return Object.keys(uploadedData[0]).map((key) => ({
      title: key,
      dataIndex: key,
      key,
      render: (val: any) =>
        typeof val === "object" ? JSON.stringify(val) : val,
    }));
  }, [uploadedData]);

  return (
    <>
      <CustomModal
        width={600}
        title="Vendor Payment File"
        open={open}
        handleClose={handleClose}
        footer={null}
      >
        <div className="p-6">
          <label className="text-[#3d4a5c] text-sm font-medium leading-normal mb-1.5 inline-block">
            Import Vendor Payment File
          </label>
          <Dragger
            name="file"
            action=""
            accept=".xlsx, .xls"
            maxCount={1}
            showUploadList={false}
            beforeUpload={() => false}
            onChange={(info) => handleUploadFile(info.file)}
            onDrop={(e) => handleUploadFile(e.dataTransfer.files[0])}
            // excelPostLoading ||
            disabled={isCreateVendorBatchLoading}
            className="import_excel mb-5 excel-upload"
          >
            <Button
              className="flex justify-between items-center disabled:!bg-transparent"
              size="large"
              disabled={isCreateVendorBatchLoading}
              style={{ width: "100%" }}
            >
              <div className="flex items-center gap-2 text-sm font-normal font-roboto text-[#8797ae]">
                <span className="text-accent font-medium text-base leading-7 relative">
                  Choose File
                </span>
                <span className="border-r border-solid border-l-0 border-y-0 border-others-border h-4" />
                {loading ? "Uploading..." : fileName}
              </div>
            </Button>
          </Dragger>
          <div className="flex items-center gap-1.5 mt-1 mb-3">
            <span className="text-body-text text-sm leading-normal">
              Download Sample File
            </span>
            <Button
              className="download-button !p-0 !h-fit !border-none !shadow-none !font-semibold"
              size="small"
              icon={<DownloadIcon />}
              type="link"
              href="/Vendor Payment Format.xlsx"
              target="_blank"
              download
            >
              Download
            </Button>
            {!uploadedData.length ? null : (
              <Button
                className="download-button !p-0 !h-fit !border-none !shadow-none !font-semibold"
                size="small"
                icon={<EyeFilled />}
                onClick={() => handlePreviewOpen({ type: "VIEW" })}
              >
                Preview
              </Button>
            )}
          </div>

          <Form
            className="custom-form"
            layout="vertical"
            requiredMark="optional"
            size="large"
            onFinish={onFinish}
            form={form}
          >
            <Form.Item
              label="Batch Name"
              name="batchName"
              rules={[
                {
                  required: true,
                  message: "Please enter the vendor payment batch name",
                },
              ]}
            >
              <Input placeholder="Enter vendor payment batch name" />
            </Form.Item>

            <div className="flex justify-center mt-7">
              <Button
                size="large"
                type="primary"
                className="w-72 !h-12"
                htmlType="submit"
                loading={isCreateVendorBatchLoading}
              >
                Upload
              </Button>
            </div>
          </Form>
        </div>

        <CustomModal
          title="Vendor Payment Preview"
          open={openPreview.open}
          handleClose={handleClosePreview}
          width={900}
          footer={null}
        >
          <Table
            dataSource={uploadedData?.map((item) => ({
              ...item,
              bankData: "N/A",
            }))}
            columns={previewColumns}
            rowKey={(record, index) => (index as number).toString()}
            scroll={{ x: true }}
            pagination={{ pageSize: 10 }}
          />
        </CustomModal>
      </CustomModal>
    </>
  );
}
